import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { ComSpecBlockType } from 'src/app/model/commodities-graph';
import { GraphView } from 'src/app/model/generic-graph';
import { FCF } from 'src/app/model/kpi-graphs';
import { NavigationOptions } from 'src/app/model/queryParams';
import { VerticalGraph } from 'src/app/model/vertical-views';

@Component({
  selector: 'app-fcf-slide',
  templateUrl: './fcf-slide.component.html',
  styleUrls: ['./fcf-slide.component.scss']
})
export class FcfSlideComponent {
  @Input() data!: GraphView;
  @Input() colIndex: number = 0;
  @Input() navInfo: NavigationOptions = {};

  public selectedBusinessGroup: string = ComSpecBlockType[0];
  public currentVerticalGraph: VerticalGraph | null = null;
  public types: any = ComSpecBlockType;
    
  constructor(private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    if(!this.colIndex) {
      this.colIndex = (this.data.graph.data as FCF).graph.data.findIndex(col => col.isDefault)
    }
  }

  selectBar(index: number){
    this.colIndex = index;
    this.cdr.detectChanges();
  }
}
